$('#rating input[type=radio]').change(function(){
	var val = $(this).val();
	$('#rating input[type=radio]').each(function(){
		if ($(this).val() < val)
			$(this).addClass('checked');
		else
			$(this).removeClass('checked');
	});
});


function showGood()
{
	$.ajax({
		type: "POST",
		url: window.location,
		data: {f_rate: 5},
		success: function(html){
			$('main').html('<div id="review"><div class="question">Спасибо за Ваш ответ!</div></div>');
		},
		error: function(e)
		{
			alert(e);
		}
	});
	
	//$('#review_star input[name=f_rate]').val(5);
	//$('#review_star').submit();
}
